import { createElement } from 'rax';
import classNames from 'classnames';
export default ((props: {
  type: string;
  className: string;
  [key: string]: any;
}) => {
  const {
    type,
    className,
    ...others
  } = props;
  let cls = classNames({
    industry_iconfont: true,
    [className]: className
  });
  cls += ` icon-${type || ''}`;
  return <i {...others} className={cls} />;
});